export default __webpack_public_path__ + "static/media/Bajaj.809f57de.png";